"use client";

import { BASE_URL, PROVINCE } from "@/src/const/const";
import { Button, Col, Form, Input, message, Row, Select } from "antd";
import React, { useState } from "react";
// import { createContactAdvise } from "../../service";
import TextArea from "antd/es/input/TextArea";
import logo_doc from "@/public/image/logo_doc.webp";
import axios from "axios";
import { strVNForSearch } from "@/src/util/util";
import moment from "moment";
import Image from "next/image";
import "./booking-form.scss";
const FormItem = Form.Item;
export const filterOption = (input, option) => {
  if (option?.value) {
    return strVNForSearch(option.children).includes(strVNForSearch(input));
  } else {
    return false;
  }
};
const BookingForm = (props) => {
  const [form] = Form.useForm();
  const [successSent, setSuccessSent] = useState(false);
  const [dataClinic, setDataClinic] = useState(props.dataClinic);
  const [messageApi, contextHolder] = message.useMessage();
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const onSelectProvince = async (value) => {
    const listClinic = await axios.get(`${BASE_URL}/clinic/search`, {
      params: {
        province_id: value,
        page: 1,
        limit: 100,
      },
    });
    console.log(listClinic);
    setDataClinic([...listClinic?.data?.data]);
  };
  const onSubmit = async () => {
    const fieldsValue = await form.validateFields();
    try {
      const body = {
        ...fieldsValue,
        type: "BLOG",
        created_at: moment(new Date()).format("HH:mm - DD/MM/YYYY"),
        landing_page_url: localStorage?.getItem("firstVisitPage")
          ? localStorage?.getItem("firstVisitPage")
          : window?.location?.href,
        referrer: localStorage?.getItem("referrer")
          ? localStorage?.getItem("referrer")
          : "",
        url: window?.location?.href,
      };
      await axios.post(`${BASE_URL}/contact-advice`, body, {
        headers: { "Content-Type": "application/json" },
      });
      form.resetFields();
      setSuccessSent(true);
    } catch (error) {
      console.log(error.message);
      messageApi.error("Kiểm tra lại Thông tin đăng bài!");
    }
  };
  return (
    <div className="rightBlock">
      <div className="formContact">
        {successSent && (
          <div className={"formSuccess"}>
            <Image src={logo_doc} alt="logo_doc" className="logo" />
            <div className="titleAbove">
              Nền tảng tìm kiếm nha khoa & review nha khoa hàng đầu
            </div>
            <div className="titleSuccess">Bạn đã đăng ký thành công!</div>
            <div className="titleBelow">
              Cảm ơn bạn đã tin tưởng và sử dụng dịch vụ của chúng tôi!
            </div>
          </div>
        )}
        {!successSent && (
          <>
            <div className="title">Đặt lịch tư vấn miễn phí!</div>
            {contextHolder}
            <Form
              form={form}
              layout="vertical"
              className="wrapper-form-contact-blog"
              onSubmit={onSubmit}
            >
              <Row gutter={[24, 0]}>
                <Col xs={24} sm={12} md={24} xl={24}>
                  <FormItem
                    name="customer_name"
                    rules={[
                      {
                        required: true,
                        message: "Bạn chưa nhập Họ tên",
                      },
                    ]}
                    label={
                      <label style={{ color: "#FFFFFF" }}>Họ và tên:</label>
                    }
                  >
                    <Input className="customInput" />
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={24} xl={24}>
                  <FormItem
                    name="customer_phone_number"
                    rules={[
                      {
                        required: true,
                        message: "Bạn chưa nhập Số điện thoại",
                      },
                      {
                        pattern: /(03|05|07|08|09)+([0-9]{8})\b/,
                        message: "Số điện thoại không đúng định dạng",
                      },
                    ]}
                    label={
                      <label style={{ color: "#FFFFFF" }}>Số điện thoại:</label>
                    }
                  >
                    <Input className="customInput" inputMode="numeric" />
                  </FormItem>
                </Col>
                <Col span={24}>
                  <FormItem
                    name="province_id"
                    label={<label style={{ color: "#FFFFFF" }}>Khu vực:</label>}
                  >
                    <Select
                      showSearch
                      filterOption={filterOption}
                      placeholder="Chọn khu vực"
                      onChange={(e) => onSelectProvince(e)}
                    >
                      {PROVINCE.map((service) => {
                        return (
                          <Select.Option key={service.id} value={service.id}>
                            {service.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </FormItem>
                </Col>
                <Col span={24}>
                  <FormItem
                    name="clinic_id"
                    label={
                      <label style={{ color: "#FFFFFF" }}>Phòng khám:</label>
                    }
                  >
                    <Select
                      showSearch
                      filterOption={filterOption}
                      placeholder="Chọn phòng khám"
                    >
                      {dataClinic &&
                        dataClinic.map((clinic) => {
                          return (
                            <Select.Option key={clinic.id} value={clinic.id}>
                              {clinic.name}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </FormItem>
                </Col>
                <Col span={24}>
                  <FormItem
                    name="note"
                    label={
                      <label style={{ color: "#FFFFFF" }}>
                        Vấn đề cần tư vấn:
                      </label>
                    }
                    style={{ marginBottom: isMobile ? 18 : 14 }}
                  >
                    <TextArea className="customTextArea" />
                  </FormItem>
                </Col>
              </Row>
              <div style={{ lineHeight: "15px" }}>
                <span className="note">LƯU Ý: Trường có dấu</span>
                <span className="labelRequired">*</span>
                <span className="note">là trường bắt buộc</span>
              </div>
              <Button
                className="btnContact"
                type="primary"
                htmlType="submit"
                onClick={onSubmit}
              >
                {isMobile ? "Liên hệ ngay" : "Đặt lịch tư vấn"}
              </Button>
            </Form>
          </>
        )}
      </div>
    </div>
  );
};

export default BookingForm;
